<template>
    <div class="container-fluid">
        <!-- Alert Messages -->
        <dl v-if="msg !== ''" class="row mt-3 mb-n3">
            <dd class="col-12">
                <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                    <i class="fas fa-exclamation-circle"></i> {{ msg }}
                </div>
            </dd>
        </dl>

        <!-- Billing -->
        <div class="row mt-5">
            <div class="col-12 pl-0">
                <h5>Billing Cycle</h5>
                <p class="mt-4 mb-0">
                    Your monthly <router-link :to="{ name: 'seller-plans' }" class="text-dark-green">
                        shop+ 
                    </router-link>bill will automatically display here and notify you via email a week before it's due date.
                </p>
                <small>P.S: Failure to pay before the due date may affect your shop+ access.</small>
            </div>
        </div>
        
        <!-- History -->
        <div class="row mt-3">
            <div class="col-12 pl-0">
                <!-- do not refresh message -->
                <dl v-if="tempShopAccessStatus" class="row mt-3">
                    <dd class="col-12">
                        <div :class="`alert alert-warning text-center mb-n4 p-1`" role="alert">
                            <i class="fas fa-exclamation-circle"></i> Temporary Access - DO NOT RELOAD PAGE!
                        </div>
                    </dd>
                </dl>

                <!-- Display billing history -->
                <div class="table-responsive">
                    <table class="table table-striped">
                        <thead class="bg-silver">
                            <tr>
                                <th>#</th>
                                <th>BillCode</th>
                                <th>From</th>
                                <th>To</th>
                                <th>Days</th>
                                <th>Amount</th>
                                <th>Generated</th>
                                <th>Paid</th>
                            </tr>
                        </thead>
                        <tbody v-if="myBillings">
                            <tr v-for="(bill, i) in myBillings" :key="i">
                                <td>{{i+1}}.</td>
                                <td>{{bill.billCode}}</td>
                                <td>{{bill.starts | moment("MMM D 'YY")}}</td>
                                <td>{{bill.stops | moment("MMM D 'YY")}}</td>
                                <td>{{bill.daysCount}}</td>
                                <td class="text-uppercase">{{bill.currency}} {{bill.amount | money}}</td>
                                <td>{{bill.joined | moment("MMM D 'YY")}}</td>
                                <td>
                                    <span v-if="bill.paid" class="text-dark-green font-weight-bold">
                                        {{bill.paidTime | moment("MMM D 'YY")}}
                                    </span>
                                    <span v-else @click="payBillFxn(bill._id)" class="loadn btn btn-danger btn-sm">Pay Now</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- import scroll table message -->
                <app-table-scroll-msg></app-table-scroll-msg>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TableScrollMsg from '@/components/user/shared/TableScrollMsg.vue'

export default {
    name: "Billing",
    data() {
        return {
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['fetchShopRent', 'fetchBillings', 'payBill', 'completePayBill', 'grantTempShopAccess', 'destroyTempShopAccess']),
        grantTempShopAccessFxn() {
            this.grantTempShopAccess().then(() => {}).catch((e) => {})
        },
        destroyTempShopAccessFxn() {
            this.destroyTempShopAccess().then(() => {}).catch((e) => {})
        },
        fetchMyBillings() {
            let userObj = {
                userId: this.user._id
            }
            this.fetchBillings(userObj).then(() => {}).catch((e) => {})
        },
        payBillFxn(selectedBill) {
            if(!this.myShop && !this.tempShopAccessStatus) return 
            let billObj = {
                billId: selectedBill
            }
            /*
            *   temp store the billObj in localStorage so after the payment gateway redirects 
            *   to this page we can use it to send the final api request to give user value for their money
            */
            localStorage.setItem('_s26pb17u', JSON.stringify(billObj))
            
            // append the userId after localStorage, security reasons!
            billObj.userId = this.user._id
            this.payBill(billObj)
            .then((data) => {
                this.color = "success" 
                this.msg = data.msg
            }).catch((e) => {
                this.msg = "Sorry, we are unable to process your payment at this time. Try again!"
            })
        },
        completePayBillFxn(transactionId) {
            let billPayload = JSON.parse(localStorage.getItem('_s26pb17u'))
            // very important! It stops the page from going into loop! Removed by vuex after payment validation
            if(!billPayload) return
            let valueObj = {
                transactionId,
                userId: this.user._id,
                billId: billPayload.billId
            }
            this.completePayBill(valueObj) 
            .then((data) => {
                if(!data.error){
                    this.color = 'success'
                    // after successful shop-plus payment, turn off temp-access-mode
                    this.destroyTempShopAccessFxn()
                    
                    // now redirect user to properly sign-in to shop+ to obtain their shop-plus details
                    if(!localStorage.getItem('_t13st40q')){
                        this.$router.push({
                            name: 'lock-screen'
                        }).catch((e) => {})
                    }

                    // // save transaction log for shop+ bill payment
                    // let eventObj = {
                    //     userId: this.user._id,
                    //     shopId: data.result._id,
                    //     event: `Shop+ upgrade - ${data.result.shopName} - successful!`
                    // }
                    // this.createTransaction(eventObj).then(() => {}).catch((e) => {})
                }
                this.msg = data.msg
            })
            .catch((e) => {})
        }
    },
    computed: {
        ...mapGetters(['user', 'shopRent', 'shopBillings', 'userShop', 'tempShopAccess']),
        myBillings() {
            if(this.shopBillings && this.shopBillings.length){
                return this.shopBillings
            }
            return false
        },
        theShopRent() {
            if(this.shopRent && this.shopRent !== null){
                return this.shopRent
            }
            return false
        },
        myShop() {
            if(this.userShop && this.userShop !== null){
                return this.userShop
            }
            return false
        },
        tempShopAccessStatus() {
            if(this.tempShopAccess && this.tempShopAccess !== null) {
                return this.tempShopAccess
            }
            return false
        },
    },
    components: {
        appTableScrollMsg: TableScrollMsg
    },
    mounted() {
        this.fetchMyBillings()
        this.fetchShopRent().then(() => {}).catch((e) => {})
        if(this.$route.query.status && this.$route.query.status === "successful"){
            // turn on the temp-access-mode
            this.grantTempShopAccessFxn()
            this.completePayBillFxn(this.$route.query.transaction_id)
        } else {
            // if payment was not successful remove the already stored complete...Obj from localStorage
            if(localStorage.getItem('_s26pb17u')){
                localStorage.removeItem('_s26pb17u')
            }
        }
        // send user back to selling page if this page is refreshed while on temp access mode
        if(!localStorage.getItem('_t13st40q') && !this.tempShopAccessStatus){
            this.$router.push({
                name: 'selling'
            }).catch((e) => {})
        }
    }
}
</script>